import { render, staticRenderFns } from "./pdf-content.vue?vue&type=template&id=72165e60"
import script from "./pdf-content.vue?vue&type=script&lang=ts"
export * from "./pdf-content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports